import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { data_fields } from 'src/app/misc/interface/data';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';

@Component({
  selector: 'app-list-services',
  templateUrl: './list-services.component.html',
  styleUrls: [
    './list-services.component.scss',
    '../search-result/search-result.component.scss',
    '../data-view/data-view.component.scss',
  ]
})
export class ListServicesComponent {
  data_type: any;
  ou_id: any;
  items: any;
  ou_object: any = { name: "Loading..." };
  fieldTypes: any[] = [];
  data: any[] = [];
  GlobalConstants = GlobalConstants

  constructor(
    private route: ActivatedRoute,
    private dataService: DataService
  ) { }

  ngOnInit() {
    if (this.fieldTypes.length == 0) {
      this.fetchFieldType();
    }
    this.route.params.subscribe(params => {

      this.ou_id = params['id'];
      this.data_type = params['type'];

      if (this.ou_id && this.data_type) {
        this.getOu();
        this.fetchdatalistfromOU();
        this.getPrintDataView();
      }
    })
  }


  private async getPrintDataView(): Promise<void> {
    try {
      let res = await this.dataService.postData('data/data-view', { "breadcrumbs.id": Number(this.ou_id), "type.arabic": this.data_type });

      this.data = res.data?.map((currentItem: any) => {
        currentItem.fields?.sort((a: data_fields, b: data_fields) => {
          if (a.label?.priority && b.label?.priority) {
            return a.label?.priority - b.label?.priority;
          } else {
            return 0;
          }
        });

        currentItem.breadcrumbs.sort((a: any, b: any) => {
          return b.depth - a.depth;
        });
        return currentItem;
      });

    } catch (e) {
      console.log(e)
    }
  }

  private async fetchFieldType(): Promise<void> {
    let res = await this.dataService.postData('field-type/get/', {
      active: true,
    });
    // console.log(res.data);
    if (res.error) {
      return;
    }
    this.fieldTypes = res.data;
  }

  async getOu() {
    try {
      let url = 'ou/byId?id=' + this.ou_id
      let res = await this.dataService.getData(url);

      this.ou_object = res.data[0];

    } catch (e) {
      console.log(e)
    }
  }
  async fetchdatalistfromOU() {
    try {
      let res = await this.dataService.postData('data/dataFromOuType', {
        ou: Number(this.ou_id),
        type: this.data_type
      });
      console.log("RES", res);
      this.items = res.data;
    } catch (e) {
      console.log(e);
    }
  }

  sortByDepth(items: any): any {
    // console.log(items);
    if (items) {
      return items.sort((a: any, b: any) => {
        return b.depth - a.depth;
      });
    } else {
      return [];
    }
  }

  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  getFieldType(type: any) {
    const fieldType = this.fieldTypes.find((item: any) => item._id == type);
    return fieldType ? fieldType.name : 'Unknown';
  }

}
